import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import Search from '@raise/search';
import cs from 'classnames';
import 'shared-styles/search.scss';

window.ra = () => {};

const searchClassNames = {
  label: 'raise-search-container__label',
  dropdown: 'searchDropdown'
};

class SearchWithContainer extends PureComponent {
  state = {
    isSearchExpanded: false
  };

  expandSearch = () => {
    this.setState({
      isSearchExpanded: true
    });
    const nav = document.getElementsByClassName('navbar-inner')[0];
    nav.classList.add('navbar-inner--searchExpanded');
  };

  shrinkSearch = () => {
    this.setState({
      isSearchExpanded: false
    });
    const nav = document.getElementsByClassName('navbar-inner')[0];
    nav.classList.remove('navbar-inner--searchExpanded');
  };

  render() {
    const { isSearchExpanded } = this.state;
    return (
      <div
        className={cs('raise-search-container', {
          ['raise-search-container--expanded']: isSearchExpanded
        })}
      >
        <Search
          className={""}
          classNames={searchClassNames}
          kind="small"
          onFocus={this.expandSearch}
          onBlur={this.shrinkSearch}
          isMinimized={!isSearchExpanded}
          name="search"
          placeholder="Search"
        />
      </div>
    );
  }
}
export default {
  init: () => {
    const searchPlaceholder = document.getElementById('raise-search');

    if (searchPlaceholder)
      ReactDOM.render(<SearchWithContainer />, searchPlaceholder);
  }
};
